import React, { useEffect, useRef } from 'react';
import FilterList from './filter-list';
import LocationPicker from './location-picker';
import { t } from 'i18next';


const FilterSidebar = ({
  open,
  onClose,
  selectedFilters,
  locationInfo, 
  setLocationInfo=() => {},
  onToggleFilter=() => {},
  onToggleSubOption=() => {},
}) => {
  const sidebarRef = useRef(null);;
  const inactivityTimeoutRef = useRef(null);

  const filterOptions = [
    {
      id: 2,
      name: "Offers & Free Delivery",
      symbol: "🎁",
  },
    {
      id: 1,
      name:  "Service Type",
      symbol: "⚙️",
      options: [
        {
          value: "IsDelivery",
          symbol: "🚚",
          label: "Delivery",
        },
        {
          value: "IsPickup",
          symbol: "🛍️",
          label: "Pickup",
        },
        {
          value: "IsDineIn",
          symbol: "🍽️",
          label: "Dine In",
        },
      ],
    },
    {
      id: 3,
      name: "Find Spots Near Me",
      symbol: "🔍",
      CustomComponent: <LocationPicker locationInfo={locationInfo} setLocationInfo={setLocationInfo} />,
    }
  ];

  // Handle Esc key to close
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  // Auto-close after 3s of inactivity within the sidebar when open
  useEffect(() => {
    if (!open) {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
        inactivityTimeoutRef.current = null;
      }
      return;
    }

    const element = sidebarRef.current;
    if (!element) return;

    // const INACTIVITY_MS = 3000;

    // const resetTimer = () => {
    //   if (inactivityTimeoutRef.current) {
    //     clearTimeout(inactivityTimeoutRef.current);
    //   }
    //   inactivityTimeoutRef.current = setTimeout(() => {
    //     onClose();
    //   }, INACTIVITY_MS);
    // };

    // Consider common interactions inside the sidebar as activity
    // const activityEvents = [
    //   'mousemove',
    //   'mousedown',
    //   'click',
    //   'touchstart',
    //   'touchmove',
    //   'wheel',
    //   'scroll',
    //   'pointerdown',
    //   'pointermove',
    //   'keydown',
    // ];

    // activityEvents.forEach((eventName) => element.addEventListener(eventName, resetTimer, { passive: true }));

    // // Start initial timer when opened
    // resetTimer();

    return () => {
      // activityEvents.forEach((eventName) => element.removeEventListener(eventName, resetTimer));
      // if (inactivityTimeoutRef.current) {
      //   clearTimeout(inactivityTimeoutRef.current);
      //   inactivityTimeoutRef.current = null;
      // }
    };
  }, [open, onClose]);

  if(open){
    document.body.style.overflow = 'hidden';
  }else{
    document.body.style.overflow = 'auto';
  }

  return (
    <>
      
      {/* Sidebar Container */}
      <div
        className="fixed right-0 w-full max-w-[460px] z-50"
        style={{
          top: '80px',
          height: 'calc(100vh - 80px)',
          pointerEvents: open ? 'auto' : 'none',
          opacity: open ? 1 : 0,
          visibility: open ? 'visible' : 'hidden',
        }}
      >
        <aside
          ref={sidebarRef}
          className={`relative h-full bg-white backdrop-blur-md shadow-xl transform transition-all duration-300 ease-in-out ${
            open ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
          }`}
          role="dialog"
          aria-modal="true"
        >
        {( selectedFilters?.length > 0 || locationInfo) && <div className='px-4 pt-4'>
            <button 
            className='text-16x font-medium text-brand-base-primary border border-brand-base-primary rounded-full p-2'
            onClick={()=>{
              onToggleFilter([]);
              setLocationInfo(null);
              onToggleSubOption([]);
            }}>
              {t("Clear Filters")}
            </button>
          </div>}
          {/* Content */}
          <div className="p-4 overflow-y-auto h-full user-select-none">
            <FilterList
              filterOptions={filterOptions}
              selectedFilters={selectedFilters}
              onToggleFilter={onToggleFilter}
              onToggleSubOption={onToggleSubOption}
            />
          </div>
        </aside>
      </div>
    </>
  );
};

export default FilterSidebar;
